import { gql } from "apollo-boost";

export const CHECK_BOOKING_CONFIRMATION_ELIGIBILITY = gql`
  query bookingConfirmationEligibility($bookingId: String!, $bookingType: String) {
    bookingConfirmationEligibility(bookingId: $bookingId, bookingType: $bookingType)
  }
`;